import React from 'react';
import PropTypes from 'prop-types';

import ChecklistDeleteTaskButton from '../ChecklistDeleteButton';
import ChecklistCompleteTaskButton from '../ChecklistCompleteTaskButton';

import '../ChecklistV2.less';
import './ChecklistTaskCompleteDeleteButtons.less';

const ChecklistTaskCompleteDeleteButtons = ({ deleteLabel }) => (
  <div className="checklist__completeDelete--container">
    <ChecklistCompleteTaskButton />
    <ChecklistDeleteTaskButton label={deleteLabel} />
  </div>
);

ChecklistTaskCompleteDeleteButtons.propTypes = {
  deleteLabel: PropTypes.string,
};

ChecklistTaskCompleteDeleteButtons.defaultProps = {};

export default ChecklistTaskCompleteDeleteButtons;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskCompleteDeleteButtons/ChecklistTaskCompleteDeleteButtons.jsx